const AttachmentActionTypes = {
    EDIT_ATTACHMENT: "EDIT_ATTACHMENT",
}

export default AttachmentActionTypes
